export default "__VITE_ASSET__Bg8aqkDa__"